import { NETWORK_MODE } from './networks';
import PlansABI from './abis/Plans.json';
import CoreStorageABI from './abis/CoreStorage.json';
import BoosterABI from './abis/Booster.json';
import ERC20ABI from './abis/ERC20.json';

// ============================================================================
// CONTRACT ADDRESSES — fill in once deployed
// ============================================================================
const ADDRESSES = {
  production: {
    USDT:        '0x9e5aac1ba1a2e6aed6b32689dfcf62a509ca96f3',
    CORE_STORAGE:'0xc014D1cc70dE0B313775E91d50c84cE1Ae8288Da',
    BOOSTER:     '0x419abB4d7444eAd9d4697aD751B8eC923a9Bcd76',
    PLANS:       '0x0ab399a3bEE69144BA10408350eDF8E519fb61C2'
  },
  staging: {
    USDT:        '0xBf6596a279172D330b8b732D257Ee633B6FDA911',
    CORE_STORAGE:'0x9B1f54e47Df75f36C042c4562914187Add14230a',
    BOOSTER:     '0x7A2B26f74fb7F3ba67e2Cc90c0C5709BcF98013D',
    PLANS:       '0x3df3de2c10bD52D11B0c5a45DA47C658a7150263'
  }
};

export const CONTRACT_ADDRESSES = ADDRESSES[NETWORK_MODE];

export const ABIS = {
  PLANS: PlansABI,
  CORE_STORAGE: CoreStorageABI,
  BOOSTER: BoosterABI,
  ERC20: ERC20ABI
};

export const USDT_DECIMALS = 18;
